// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"TagWrapper_tagWrapper__b1CUJ","text":"TagWrapper_text__17tcg","close":"TagWrapper_close__12vLz"};